import {createContext} from 'react';
import { DateValue } from 'react-aria';

export const CalendarContext = createContext<{cellClickHandler?:(date: DateValue) => void }>({});
